<template>
  <div class="mainContainer blaLoginContainer">
    <!-- ERROR SNIPPET -->
    <v-snackbar
      v-model="error.show"
      color="error"
      top
      :timeout="error.timeout"
      text-xs-center
    >
      {{ error.message }}
      <v-icon right dark>error_outline</v-icon>
    </v-snackbar>

    <div class="row">
      <div class="col-10 offset-1 blaLoginLogoBox">
        <img
          :src="require('@/assets/img/skillers_logo_new_purple.png')"
          class="img-fluid w-75"
          alt="Skillers logo"
          @click="$router.push({ name: 'WebApp' })"
        />
      </div>
      <div class="col-10 offset-1 col-lg-4 offset-lg-4 mt-2">
        <div class="blaLoginBox">
          <div class="blaLoginBoxTitle text-center mt-3">
            Tanulói fiók létrehozása <br>
            <small class="px-2">
              Lépj be az e-Egyetem oktatási platformjára
            </small>
          </div>
          <div class="row pt-3">
            <div class="col-10 offset-1">
              <div class="form-group mb-3">
                <label for="name">Név</label>
                <input
                  v-model="form.name"
                  type="text"
                  class="form-control blaInput"
                  placeholder=""
                  id="name"
                />
              </div>
              <div class="form-group mb-3">
                <label for="email">Email cím</label>
                <input
                  v-model="form.email"
                  type="text"
                  class="form-control blaInput"
                  id="email"
                />
              </div>
              <div class="form-group mb-3">
                <label for="password">Mi legyen a jelszavad?</label>
                <input
                  v-model="form.password"
                  type="password"
                  class="form-control blaInput"
                  id="password"
                />
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="aszf"
                  v-model="form.checkbox.aszf"
                />
                <label class="form-check-label" for="aszf"
                  >Elfogadom az ÁSZF-t</label
                >
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="sixteen"
                  v-model="form.checkbox.sixteen"
                />
                <label class="form-check-label" for="sixteen"
                  >Elmúltam 16 éves</label
                >
              </div>
            </div>
            <div class="col-10 offset-1 text-center align-content-center mt-4">
              <div class="blaLoginButton2" @click="letsRegistrate">
                Regisztráció
              </div>
            </div>
            <!--<div class="col-10 offset-1 text-center align-content-center mt-4">-->
            <!--  <hr data-content="VAGY" class="blaHr-text" />-->
            <!--</div>-->
            <!--<div class="col-10 offset-1 text-center align-content-center mt-1">-->
            <!--  <div class="row align-content-center">-->
            <!--    <div class="col-6 p-3">-->
            <!--      <div class="blaOAuthButton">-->
            <!--        <img-->
            <!--          :src="require('@/assets/img/icon_google.png')"-->
            <!--          class="blaOAuthButtonImg"-->
            <!--          alt="google"-->
            <!--        />-->
            <!--        <div class="blaOAuthButtonText">-->
            <!--          Google-->
            <!--        </div>-->
            <!--      </div>-->
            <!--    </div>-->
            <!--    <div class="col-6 p-3">-->
            <!--      <div class="blaOAuthButton">-->
            <!--        <img-->
            <!--          :src="require('@/assets/img/icon_facebook.png')"-->
            <!--          class="blaOAuthButtonImg"-->
            <!--          alt="facebook"-->
            <!--        />-->
            <!--        <div class="blaOAuthButtonText">-->
            <!--          Facebook-->
            <!--        </div>-->
            <!--      </div>-->
            <!--    </div>-->
            <!--  </div>-->
            <!--</div>-->
            <div class="col-10 offset-1 text-center my-3">
              <div class="row">
                <div class="col-12">
                  Már van fiókod?
                  <a
                    href="javascript:void(0)"
                    class="blaLoginLink"
                    @click="$router.push({ name: 'MobileMain' })"
                  >
                    Jelentkezz be!
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    error: {
      show: false,
      message: '',
      timeout: 4500
    },
    rules: {
      required: value => !!value || 'Kötelező'
    },
    loader: false,
    chooser: false,
    login: false,
    registration: true,
    formLogin: {
      email: '',
      password: '',
      remember: ''
    },
    form: {
      email: '',
      email2: '',
      name: '',
      password: '',
      passwor2: '',
      passwordShow: false,
      passwordShow2: false,
      checkbox: {
        aszf: false,
        gdpr: false,
        sixteen: false
      }
    }
  }),
  methods: {
    authenticate() {
      this.$store.dispatch('login');

      this.$data.login = false;
      this.$data.loader = true;

      axios
        .post(this.$store.getters.getApiUrl + '/api/login', {
          email: this.$data.formLogin.email,
          password: this.$data.formLogin.password
        })
        .then(response => {
          if (response.data.token.length > 0) {
            this.$store.commit('loginSuccess', {
              token: response.data.token,
              isLoggedIn: true,
              currentUser: response.data.currentUser
            });

            this.$store.commit('setIsAppState', {
              isApp: true
            });

            //Automaticaly save the email & pwd
            // if( this.$data.formLogin.remember === true )
            // {
            localStorage.loginEmail = this.$data.formLogin.email;
            localStorage.loginPassword = this.$data.formLogin.password;
            // }

            var v = this;

            setTimeout(function() {
              v.$data.loader = false;
              v.$router.push({ path: '/chooser' });
            }, 2000);
          }
        })
        .catch(error => {
          // console.log('error', error.response.data);

          var v = this;

          setTimeout(function() {
            v.$data.loader = false;
            v.$data.login = true;
            v.$data.error.message = error.response.data.message;
            v.$data.error.code = error.response.data.code;
            v.$data.error.show = true;
          }, 1000);
        });
    },
    letsRegistrate() {
      this.$data.error.show = false;

      if (
        this.$data.form.checkbox.aszf === false ||
        this.$data.form.checkbox.sixteen === false
      ) {
        this.$data.error.message = 'ÁSZF és GDPR elfogadása kötelező!';
        this.$data.error.code = '000';
        this.$data.error.show = true;
      } else if (
        this.$data.form.email.length < 1 ||
        this.$data.form.name.length < 1
      ) {
        this.$data.error.message = 'Az email cím és a név megadása kötelező!';
        this.$data.error.code = '000';
        this.$data.error.show = true;
      } else {
        this.$data.loader = true;
        this.$data.registration = false;

        axios
          .post(this.$store.getters.getApiUrl + '/api/registration', {
            email: this.$data.form.email,
            password: this.$data.form.password,
            name: this.$data.form.name
          })
          .then(response => {
            if (response.data.token !== undefined) {
              this.$store.commit('loginSuccess', {
                token: response.data.token,
                isLoggedIn: true,
                currentUser: response.data.currentUser
              });

              this.$store.commit('setIsAppState', {
                isApp: true
              });

              var v = this;
              setTimeout(function() {
                v.$data.loader = false;
                v.$router.push({ path: '/home' });
              }, 2000);
            }
          })
          .catch(error => {
            // console.log('Hibas reg: ', error.response);
            var v = this;

            setTimeout(function() {
              v.$data.loader = false;
              v.$data.registration = true;
              v.$data.error.message = error.response.data.message;
              v.$data.error.code = error.response.data.code;
              v.$data.error.show = true;
            }, 1000);
          });
      }
    },
    goToPasswordReset() {
      this.$router.push({ name: 'PasswordReset' });
    },
    showRegistration() {
      this.$data.chooser = false;
      this.$data.login = false;
      this.$data.registration = true;
    },
    showLogin() {
      this.$data.chooser = false;
      this.$data.registration = false;
      this.$data.login = true;
    },
    showChooser() {
      this.$data.login = false;
      this.$data.registration = false;
      this.$data.chooser = true;
    }
  },
  mounted() {}
};
</script>
